import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-597c97a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-creation-wizard__container" }
const _hoisted_2 = { class: "profile-creation-wizard__content-actions" }
const _hoisted_3 = { class: "profile-creation-wizard__content" }
const _hoisted_4 = { class: "details-form__item" }
const _hoisted_5 = { class: "custom-font-text" }
const _hoisted_6 = { class: "profile-creation-wizard__content-footer" }

import {computed, inject, onBeforeMount, onMounted, reactive, ref} from 'vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {useStore} from 'vuex';
    import getters from '@/profile-creation-wizard/components/for-creation/store/getters';
    import type {FunctionalScope, FunctionalSkill} from '@/profile-creation-wizard/components/for-creation/store';
    import StepActions from '@/profile-creation-wizard/common/ui/step/StepActions.vue';
    import StepMobileHeader from '@/profile-creation-wizard/common/ui/step/StepMobileHeader.vue';
    import {StepNavigator} from '@/profile-creation-wizard/common/step/StepNavigator';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import mutations from '@/profile-creation-wizard/components/for-creation/store/mutations';
    import FunctionalSkills from '@/common/components/functional-skills/FunctionalSkills.vue';
    import {useRouter} from 'vue-router';
    import {useTranslation} from '@malt/vue3-use';
    import MaltStrategyFunctionalSkillsSide from '@/profile-creation-wizard/components/for-creation/ui/functionalSkills/MaltStrategyFunctionalSkillsSide.vue';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';

    const stepName = 'functional-skills';
    const maxFunctionalSkills = 10;
    const maxGlobalSkills = 35;

    
export default /*#__PURE__*/_defineComponent({
  __name: 'MaltStrategyFunctionalSkillsStep',
  setup(__props) {

    const store = useStore();
    const {msg} = useTranslation();
    const creationForm = ref(store.getters[getters.creationForm]);
    const functional = ref<HTMLElement>(null);

    const creationFormValidation = inject(DI.creationFormValidation);
    const functionalSkillsRepository = inject(DI.functionalSkillsRepository);
    const trackingRepository = inject(DI.trackingRepository);

    const router = useRouter();
    const meta = computed(() => router.currentRoute.value.meta);
    const progressPercentage = computed(() => meta.value.progressPercentage);
    const stepNavigator = new StepNavigator(router, meta.value.previousStep, meta.value.nextStep);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const state = reactive<{availableFunctionalScopes: FunctionalScope[]}>({
        availableFunctionalScopes: [],
    });

    const hasValidFieldPart = computed(() => creationFormValidation!.isFunctionalSkillsValid(creationForm!.value.functionalSkills));

    onBeforeMount(async (): Promise<void> => {
        if (window.hj) {
            // Custom event Hotjar
            window.hj('event', 'profile_creation_details_page');
        }
        await loadFunctionalScopes();
    });

    onMounted((): void => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#details-functional-bottom-sheet',
            '',
            functional.value,
            'div.profile-creation-wizard',
        );
        bottomSheetDisplayer.value.mounted();
    });

    async function loadFunctionalScopes(): Promise<void> {
        const [scopes, error] = await functionalSkillsRepository!.loadScopes();
        if (scopes && !error) {
            state.availableFunctionalScopes = scopes;
        }
    }

    function goToPrevious(): void {
        stepNavigator.previous();
    }

    function goNext(): void {
        stepNavigator.next();
    }

    function handleSelectedSkillsChanged(functionalSkills: FunctionalSkill[]) {
        store.commit(mutations.updateFunctionalSkills, functionalSkills);
    }

    function handleGlobalSkillsAdded(globalSkill: Tag) {
        store.commit(mutations.selectTag, globalSkill);
    }

    function handleGlobalSkillsRemoved(globalSkill: Tag) {
        store.commit(mutations.unselectTag, globalSkill);
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_progress_bar = _resolveComponent("joy-progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "functional",
    ref: functional,
    class: "profile-creation-wizard ff-bottom-fixed-cta"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_joy_progress_bar, { percentage: progressPercentage.value }, null, 8, ["percentage"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(StepMobileHeader, {
            "step-name": stepName,
            "onClick:previous": goToPrevious
          }),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(StepItemTitle, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.functionalSkills.title')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("p", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.functionalSkills.subtitle', maxFunctionalSkills)) + " ", 1),
              _createElementVNode("a", {
                class: "open-bottom-sheet",
                onClick: openBottomSheet
              }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.functional.skills.title')), 1)
            ]),
            _createVNode(FunctionalSkills, {
              "available-functional-scopes": state.availableFunctionalScopes,
              "selected-skills": creationForm.value.functionalSkills,
              "global-skills": creationForm.value.tags,
              maxFunctionalSkills: maxFunctionalSkills,
              maxGlobalSkills: maxGlobalSkills,
              "onFunctionalSkills:updated": handleSelectedSkillsChanged,
              "onGlobalSkills:added": handleGlobalSkillsAdded,
              "onGlobalSkills:removed": handleGlobalSkillsRemoved
            }, null, 8, ["available-functional-scopes", "selected-skills", "global-skills"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_joy_progress_bar, {
            percentage: progressPercentage.value,
            mode: "mobile"
          }, null, 8, ["percentage"]),
          _createVNode(StepActions, {
            stepName: stepName,
            "is-disabled-button-next": !hasValidFieldPart.value,
            "onClick:next": goNext,
            "onClick:previous": goToPrevious
          }, null, 8, ["is-disabled-button-next"])
        ])
      ]),
      _createVNode(MaltStrategyFunctionalSkillsSide)
    ])
  ], 512))
}
}

})